/**
 * Listing Filter helper override for Learn Cloud Native
 * 
 */
'use strict';

import { FilterHelper } from './filter-helper.js';

export class LearnCloudFilterHelper extends FilterHelper {
    constructor() {
        super();
        this.is_infinite_scroll = false;
        this.no_more_results = false;
    }

    init() {
        super.init();
        this.init_infinite_scroll();
        this.init_loading_div();
    }

    init_search() {
        let _self = this;

        this.target.search.on('keyup input', this.debounce(function () {
            _self.config.search_term = $(this).val().trim();
            _self.config.paged = 1;
            _self.no_more_results = false; // Allow additional searches after no results is found

            if (_self.config.search_term != '') {
                $(this).parent().parent().addClass('active');
                _self.target.result_text.html(_self.config.search_term);
            }
            else {
                $(this).parent().parent().removeClass('active');
                _self.target.result_text.html('');
            }

            _self.make_ajax_request();
        }, 150));
    }

    init_loading_div() {
        const loadingDiv = $('<div class="t-v4-learn-cloud--content-loading" style="display: none;"></div>');

        // Append loading div to the pagination element
        const paginationElement = document.querySelector('.c-v4-m61-learn-cloud-cards');
        if (paginationElement) {
            $(paginationElement).append(loadingDiv);
        }

        this.show_loading = () => {
            loadingDiv.fadeIn();
        };

        this.hide_loading = () => {
            loadingDiv.fadeOut();
        };
    }

    init_infinite_scroll() {
        const _self = this;

        const createObserverElement = () => {
            const trigger = document.createElement('div');
            trigger.className = 'c-v4-m61-learn-cloud-cards-infinite-scroll-trigger';
            const paginationElement = document.querySelector('.c-v4-m61-learn-cloud-cards');
            if (paginationElement) {
                paginationElement.appendChild(trigger);

                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting && !_self.config.loading && !_self.no_more_results) {
                                _self.config.paged++;
                                _self.is_infinite_scroll = true;
                                _self.show_loading();
                                _self.make_ajax_request();
                                observer.unobserve(trigger);
                                trigger.remove();
                            }
                        });
                    }
                );

                observer.observe(trigger);
            }
        };

        createObserverElement();

        this.init_callback(createObserverElement);
    }

    /**
     * Override the init_chips method to ensure only one chip can be active at a time.
     */
    init_chips() {
        let _self = this;

        // Reset
        $('body').on('click', this.component_id + ' .filter--reset', function (e) {
            e.preventDefault();

            _self.reset();
        });

        // Chips click
        $('body').on('click', this.component_id + ' .c-chips a.chip', function (e) {
            e.preventDefault();

            if ($(this).hasClass('all')) {
                if (!$(this).hasClass('active')) {
                    $(_self.component_id + ' a.chip:not(.all)').removeClass('active');

                    $(this).addClass('active');

                    delete _self.config.terms[_self.config.chips_taxonomy];

                    _self.config.paged = 1;
                    _self.no_more_results = false;
                    _self.make_ajax_request();
                }
            } else {
                if (!$(this).hasClass('active')) {
                    $(_self.component_id + ' a.chip').removeClass('active');

                    $(this).addClass('active');

                    _self.config.terms = {};

                    if (!$(this).hasClass('default')) {
                        _self.add_term($(this));
                    }
                } else {
                    $(this).addClass('active');
                }

                // Make the AJAX request to update the content
                _self.config.paged = 1;
                _self.no_more_results = false;
                _self.make_ajax_request();
            }
        });

        this.init_chips_from_url();
    }

    init_chips_from_url() {
        let params = new URLSearchParams(window.location.search);
        let terms = params.get('terms');
        let _self = this;

        if (terms) {
            // Deselect "All Topics" chip
            $(_self.component_id + ' a.chip.all').removeClass('active');

            // Select the chips based on the terms
            terms.split(',').forEach(term => {
                let chip = $(_self.component_id + ` a.chip[data-term="${term}"]`);
                if (chip.length) {
                    chip.addClass('active');
                    _self.add_term(chip);
                }
            });
        }
    }

    /**
     * Make AJAX request and append new items for infinite scroll
     * @param {boolean} is_reset
     */
    make_ajax_request(is_reset = false) {
        const _self = this;

        if (!this.config.loading && !this.no_more_results) {
            this.config.loading = true;

            if (!this.is_infinite_scroll) {
                this.update_state();
            } else {
                this.is_infinite_scroll = false;
            }

            const data = {
                action: this.config.action,
                author_id: this.config.author_id,
                link_field: this.config.link_field,
                order_by: this.config.order_by,
                paged: this.config.paged,
                post_types: this.config.post_types,
                per_row: this.config.items_per_row,
                search: this.config.search_term,
                terms: this.config.terms,
                url: this.config.url,
                view: this.config.view,
                is_reset: is_reset,
            };

            const ajaxSuccess = (resp) => {
                _self.hide_loading();
                // Check for "no results" template in the response
                if ($(resp).find('.t-v4-learn-cloud--no-results').length > 0) {
                    if (_self.is_infinite_scroll) {
                        _self.no_more_results = true;
                        _self.config.loading = false;
                        return;
                    }
                }

                if (_self.config.paged === 1 || is_reset) {
                    _self.target.target_container.html(resp);
                    _self.no_more_results = false;
                } else {
                    if (!$(resp).find('.t-v4-learn-cloud--no-results').length > 0) {
                        _self.target.target_container.append(resp);
                    }
                }
                _self.update_count();
                _self.update_external_links();
                _self.config.loading = false;

                // Check if there are no more results
                if ($(resp).find('.t-v4-learn-cloud--no-results').length > 0) {
                    _self.no_more_results = true;
                }

                if (_self.callback) {
                    _self.callback();
                }
            };

            const ajaxError = () => {
                _self.hide_loading(); // Hide loading div
                _self.config.loading = false;
            };

            $.ajax({
                type: 'POST',
                url: sysdigLocalizedObject.ajaxUrl,
                data: data,
                success: ajaxSuccess,
                error: ajaxError,
            });
        }
    }

    /**
     * Override update_state to prevent URL update for infinite scroll
     * @param {boolean} is_default_state
     */
    update_state(is_default_state = false) {
        if (!this.is_infinite_scroll) {
            super.update_state(is_default_state);
        }
    }
}